// Bernie
import { AnalyticsStore, codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { UiStore } from 'stores';
import { PageData } from 'bernie-http';

// Utils
import analyticsUtil from '../util/AnalyticsUtil';

import { pageNames } from '../data/page-names';

class BexSearchController implements Controller {
  public bundles = [];

  public component = codeSplit(() => import(/* webpackChunkName: "bex-search-page" */ '../views/bex-search-page'));

  public pageId = pageNames.bexSearch;

  public path = '/:localeName/bex-search';
  public exact = true;

  public routeName = 'bexsearch';

  public fetch(options: FetchOptions) {
    const { stores, request } = options;

    const analyticsStore: AnalyticsStore = stores?.get<AnalyticsStore>('analytics');

    const uiStore = stores?.get<UiStore>('uiStore');
    uiStore?.setPageName(this.pageId);

    analyticsUtil.runAnalytics(this.pageId, analyticsStore, request.context);

    return Promise.resolve(Result.ok());
  }

  public fetchPageData() {
    const pageData: PageData = {
      title: 'Expedia Search Widget',
    };

    return Promise.resolve(pageData);
  }
}

export { BexSearchController };
